import { useCallback, useEffect, useState } from "react"
import useSWRInfinite from "swr/infinite"

export function usePagination<
  R extends {
    nextPageToken?: string
    totalCount: number
  }
>(
  baseUrl: string,
  pageSize: number,
  autoLoad: boolean,
  queryFilters: string[] = [],
  queryParameters: { [key: string]: string } = {}
) {
  // TODO: useCallback을 사용하는 것은 현재 시점에서는 의미가 없으나,
  // 이후에 dependency를 관리하게 되면 필요해질 것.
  const getSWRKey = useCallback(
    (pageIndex: number, previousPageData: R | null) => {
      // Reached the end
      if (previousPageData && !previousPageData.nextPageToken) return null
      const token = previousPageData?.nextPageToken
      const queryParams = new URLSearchParams({
        ...(queryFilters && { filter: queryFilters!.join(";") }),
        page_size: pageSize.toString(),
      })
      if (token) {
        queryParams.append("page_token", token)
      }
      if (queryParameters) {
        Object.keys(queryParameters).forEach((key) => {
          queryParams.append(key, queryParameters[key])
        })
      }
      return `${baseUrl}?${queryParams}`
    },
    [queryFilters]
  )
  const { data, mutate, size, setSize } = useSWRInfinite<R>(getSWRKey)
  const [isLoading, setLoading] = useState(true)
  const firstPage = data?.[0]
  useEffect(() => {
    if (autoLoad && firstPage) {
      const totalSize = Math.ceil(firstPage.totalCount / pageSize)
      if (totalSize <= 1) {
        setLoading(false)
      }
      setSize(totalSize)
    }
  }, [firstPage, setSize])
  useEffect(() => {
    if (autoLoad && size > 1 && data?.[size - 1]) {
      setLoading(false)
    }
  }, [size, data])
  return { data, mutate, size, setSize, isLoading }
}
